<template>
  <!-- 详情 -->
  <div class="inbox detailssdd">
    <div class="top_center">
      <div class="inlbox">
        <div class="list flex baff">
          <div class="name">
            <div class="name_heder">
              <img class="ru50" :src="detai.headSrc" alt />
            </div>
            <div class="hotbq sz26 co6e font_a" v-if="detai.tagNew">NEW!</div>
            <div class="hotbq sz26 co6e font_a" v-else-if="detai.tagHot">
              HOT!
            </div>
            <div class="hotbq sz26 co6e font_a" v-else-if="detai.tagActive">
              ACTIVE!
            </div>
          </div>
          <div class="category">
            <div class="mb20 flex alcen">
              <el-tooltip
                class="item"
                effect="dark"
                :content="detai.name"
                placement="top"
              >
                <p class="category_ttname sz20 h25 font_bo mr">
                  {{ detai.name }}
                </p>
              </el-tooltip>
              <span class="sz14 _top">{{ detai.countryName }}</span>
            </div>
            <div class="operateview">
              <el-row :gutter="20">
                <el-col style="padding-right: 5px" :span="6">
                  <div class="operateview_item">
                    <el-tooltip
                      v-if="detai.isConcern == 1"
                      class="item"
                      effect="dark"
                      content="取消关注"
                      placement="left"
                    >
                      <img
                        class="cursor"
                        src="@/assets/img/home/love.png"
                        alt
                        @click="delConcern(detai)"
                      />
                    </el-tooltip>
                    <el-tooltip
                      v-else
                      class="item"
                      effect="dark"
                      content="关注"
                      placement="left"
                    >
                      <img
                        class="cursor"
                        src="@/assets/img/foll/love2new.png"
                        alt
                        @click="addConcern(detai)"
                      />
                    </el-tooltip>
                  </div>
                </el-col>
                <el-col style="padding-right: 5px" :span="6">
                  <div class="operateview_item">
                    <el-tooltip
                      v-if="detai.isCooperate == 1"
                      class="item cursor"
                      effect="dark"
                      content="移除合作分组"
                      placement="right"
                    >
                      <img
                        src="@/assets/img/foll/ws2new.png"
                        class
                        alt
                        @click="delCooperate(detai)"
                      />
                    </el-tooltip>
                    <el-tooltip
                      v-else
                      class="item cursor"
                      effect="dark"
                      content="加入合作分组"
                      placement="right"
                    >
                      <img
                        src="@/assets/img/foll/wsnew.png"
                        class
                        alt
                        @click="addCooperate(detai)"
                      />
                    </el-tooltip>
                  </div>
                </el-col>
                <el-col style="padding-right: 5px" :span="6">
                  <div class="operateview_item3">
                    <el-tooltip
                      v-if="detai.hasEmail == 1"
                      class="item"
                      effect="dark"
                      content="发送邮件"
                      placement="left"
                    >
                      <img
                        class="cursor topsa"
                        src="@/assets/img/foll/emlnew.png"
                        alt
                        @click="sendOut(detai)"
                      />
                    </el-tooltip>
                    <el-tooltip
                      v-else
                      class="item"
                      effect="dark"
                      content="暂无邮箱，更新中"
                      placement="left"
                    >
                      <img
                        class="cursor topsa"
                        src="@/assets/img/foll/eml1new.png"
                        alt
                      />
                    </el-tooltip>
                  </div>
                </el-col>
                <el-col style="padding-right: 5px" :span="6">
                  <div class="operateview_item4">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="加入分组"
                      placement="right"
                    >
                      <img
                        class="cursor"
                        src="@/assets/img/foll/gdnew.png"
                        alt
                        @click="addgrouping(detai)"
                      />
                    </el-tooltip>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <!-- <div class="scoreview">
            <el-row style="width: 100%" :gutter="20">
              <el-col v-if="detai.relevancyScore" style="padding-right: 5px" :span="12">
                <div class="scoreview_item">
                  <p>Relevancy Score</p>
                  <div class="score_val">{{ detai.relevancyScore }}<span class="dfont"></span></div>
                </div>
              </el-col>
              <el-col style="padding-right: 5px" :span="24">
                <div class="scoreview_item">
                  <p>Quality Score</p>
                  <div class="score_val">{{ detai.qualityScore }}<span class="dfont"></span></div>
                </div>
              </el-col>
            </el-row>
          </div>-->
          <div class="affiliate flex">
            <p class="sz14 titnames h25">联盟平台</p>
            <div v-if="detai.affiliateNetworkLogos" class="foll_titless">
              <el-tooltip
                v-for="(itmr, index3) in detai.affiliateNetworkLogos"
                :key="index3"
                class="item"
                effect="dark"
                :content="detai.affiliateNetworks[index3]"
                placement="bottom-end"
              >
                <img :src="itmr" alt />
              </el-tooltip>
            </div>
          </div>

          <!-- <div class="affiliate flex">
            <p class="sz14 titnames h25">联盟平台</p>
            <div v-if="detai.affiliateNetworkLogos" class="foll_titless">
              <p
                class="foll_tt2 center ru5 sz12"
                v-for="(itmr, index3) in detai.affiliateNetworkLogos"
                :key="index3"
                v-show="index3 < 8"
              >
                <img :src="itmr" alt />
              </p>
            </div>
          </div> -->
        </div>

        <!-- SEMRush  -->
        <p class="flex sz12 mb5 times" v-if="detai2.updateTime">
          *数据更新时间截止为{{ detai2.updateTime }}
        </p>

        <div class="details ru5">
          <el-row
            type="flex"
            :gutter="20"
            justify="space-between"
            style="margin: 0px; background-color: #fff"
          >
            <el-col
              :span="24"
              style="
                padding-left: 0;
                padding-right: 0;
                background-color: #fff;
                box-shadow: 0 0 0.25rem 0 rgba(0, 0, 0, 0.05);
              "
            >
              <div class="w100 flex">
                <div class="tabs ru5 baff flex">
                  <div
                    class="font_a cursor"
                    :class="borstuts == index ? 'bor' : ''"
                    v-for="(item, index) in detai2List"
                    :key="index"
                    @click="borscick(item, index)"
                  >
                    {{ item.prompType }}
                  </div>
                  <div
                    v-if="
                      chartnum1 > 0 ||
                      chartnum2 > 0 ||
                      chartnum3 > 0 ||
                      chartnum4 > 0 ||
                      googs.length > 0
                    "
                    class="font_a cursor"
                    :class="borstuts == 'default' ? 'bor' : ''"
                    @click="detailclick"
                  >
                    渠道详情
                  </div>
                </div>
              </div>
              <div v-if="borstuts === 'default'" class="detailbox">
                <div
                  v-if="
                    chartnum1 > 0 ||
                    chartnum2 > 0 ||
                    chartnum3 > 0 ||
                    chartnum4 > 0
                  "
                  class="blocktitle"
                >
                  <span class="nodered"></span>相关性分析
                </div>
                <div
                  v-if="
                    chartnum1 > 0 ||
                    chartnum2 > 0 ||
                    chartnum3 > 0 ||
                    chartnum4 > 0
                  "
                  class
                >
                  <el-row style="border-bottom: 1px solid #f2f2f2">
                    <el-col :span="12" v-if="chartnum1 > 0">
                      <div class="chart chartone">
                        <div class="newtitle">
                          区域影响力
                          <el-tooltip
                            class="item"
                            effect="dark"
                            content="通过统计联盟客在带货链接品牌所属地区的带货链接数量，统计联盟客的区域影响力。"
                            placement="right"
                          >
                            <i class="el-icon-question"></i>
                          </el-tooltip>
                        </div>
                        <div id="chart1"></div>
                      </div>
                    </el-col>
                    <el-col :span="12" v-if="chartnum2 > 0">
                      <div class="chart chartone">
                        <div class="newtitle">
                          联盟平台
                          <el-tooltip
                            class="item"
                            effect="dark"
                            content="通过统计联盟客推广的联盟平台带货链接数量，统计联盟客的联盟平台。"
                            placement="right"
                          >
                            <i class="el-icon-question"></i>
                          </el-tooltip>
                        </div>
                        <div id="chartdhhyZ"></div>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom: 50px">
                    <el-col :span="12">
                      <div class="chart chartone" v-if="chartnum3 > 0">
                        <div class="newtitle">
                          合作品牌
                          <el-tooltip
                            class="item"
                            effect="dark"
                            content="通过统计联盟客推广的品牌带货链接数量，统计联盟客的带货品牌。"
                            placement="right"
                          >
                            <i class="el-icon-question"></i>
                          </el-tooltip>
                        </div>
                        <div id="charthzpp"></div>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="chart chartone" v-if="chartnum4 > 0">
                        <div class="newtitle">
                          带货行业
                          <el-tooltip
                            class="item"
                            effect="dark"
                            content="通过统计联盟客推广的品牌归属行业带货链接数量，统计联盟客的带货行业。"
                            placement="right"
                          >
                            <i class="el-icon-question"></i>
                          </el-tooltip>
                        </div>
                        <div id="chart2"></div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div
                  v-if="
                    focusTopicNum > 0 ||
                    contentTypeNum > 0 ||
                    contentStyleNum > 0
                  "
                  class="details-block ru5"
                >
                  <div class="blocktitleBord">
                    <span class="nodered"></span>内容分析
                  </div>
                  <div v-if="focusTopicNum > 0" class>
                    <el-row>
                      <el-col :span="24">
                        <div class="chart chartcontent">
                          <div class="otherbox">
                            <div class="newtitle">
                              焦点话题
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="通过统计联盟客发布内容中出现频率最高的词汇，归纳联盟客的焦点话题。"
                                placement="right"
                              >
                                <i class="el-icon-question"></i>
                              </el-tooltip>
                            </div>
                            <div id="chart5">
                              <div id="jdht"></div>
                            </div>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <div class>
                    <el-row>
                      <el-col v-if="contentTypeNum > 0" :span="12">
                        <div class="chart chartcontent">
                          <div class="otherbox">
                            <div class="newtitle">
                              内容类型
                              <el-tooltip
                                class="item"
                                effect="dark"
                                placement="right"
                              >
                                <div slot="content">
                                  <p>
                                    通过统计联盟客发布内容中各类型内容的数量，归纳联盟客的内容类型。包括：
                                  </p>
                                  <p>
                                    a. Product reviews:
                                    产品评论，对产品的评价和评测。
                                  </p>
                                  <p>
                                    b. Product comparisons:
                                    产品比较，对多个产品进行比较和对比。
                                  </p>
                                  <p>
                                    c. Product roundups:
                                    产品汇总，对多个产品进行汇总和推荐。
                                  </p>
                                  <p>
                                    d. Tutorials: 教程，提供操作指南和教学。
                                  </p>
                                  <p>
                                    e. Gift guides:
                                    礼物指南，提供礼物选择和推荐。
                                  </p>
                                  <p>
                                    f. Case studies:
                                    案例研究，通过案例分析来展示产品或服务的优势。
                                  </p>
                                  <p>
                                    g. Buyer’s guides:
                                    买家指南，提供购买建议和指南。
                                  </p>
                                  <p>
                                    h. Curations: 策展，精选和推荐优质内容。
                                  </p>
                                  <p>
                                    i. Deals and coupons:
                                    优惠券，提供优惠信息和折扣券。
                                  </p>
                                  <p>
                                    j. Product
                                    placement：产品在生活视频中露出或植入产品，但没有对产品做专门介绍，以增强受众信任。
                                  </p>
                                </div>
                                <i class="el-icon-question"></i>
                              </el-tooltip>
                            </div>
                            <div id="chart6"></div>
                          </div>
                        </div>
                      </el-col>
                      <el-col v-if="contentStyleNum > 0" :span="12">
                        <div class="chart chartcontent">
                          <div class="otherbox">
                            <div class="newtitle">
                              内容风格
                              <el-tooltip
                                class="item"
                                effect="dark"
                                placement="right"
                              >
                                <div slot="content">
                                  <p>
                                    通过统计联盟客发布内容的写作展示风格特点，归纳联盟客的内容风格。包括：
                                  </p>
                                  <p>
                                    a. Casual: 随意，不拘泥于形式，轻松自然。
                                  </p>
                                  <p>
                                    b. Storytelling:
                                    讲故事，通过讲述故事来吸引读者。
                                  </p>
                                  <p>
                                    c. Listicles: 清单，以清单形式呈现信息。
                                  </p>
                                  <p>d. How-to: 如何做，提供操作指南和步骤。</p>
                                  <p>e. Q&A: 问答，以问答形式呈现信息。</p>
                                  <p>
                                    f. Inspirational: 励志，鼓舞人心，激励读者。
                                  </p>
                                  <p>g. Humorous: 幽默，幽默诙谐，娱乐读者。</p>
                                  <p>
                                    h. Visual: 视觉，以视觉元素为主要表现形式。
                                  </p>
                                </div>
                                <i class="el-icon-question"></i>
                              </el-tooltip>
                            </div>
                            <div id="chart7"></div>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div class="details ru5" v-if="googs.length > 0">
                  <div class="blocktitleBord">
                    <span class="nodered"></span>
                    {{ typesName == "B端" ? "热销商品" : "近期带货商品" }}
                  </div>
                  <div class>
                    <el-row>
                      <el-col :span="24">
                        <div class="goodsnear">
                          <div class="rightt">
                            <div class="rightt_center">
                              <el-row :gutter="20">
                                <el-col
                                  :span="4"
                                  v-for="(item, index) in googs"
                                  :key="index"
                                  v-show="index < 6"
                                >
                                  <div class="top_imgreset">
                                    <img :src="item" alt />
                                  </div>
                                </el-col>
                              </el-row>
                            </div>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
              <div v-if="borstuts !== 'default'">
                <div class="leftt">
                  <div class="sz20 co00 font_bo titlee flex alcen">
                    {{ detai2.title }} &nbsp;
                    <img
                      v-if="typesName !== 'B端' && detai2.websiteUrl"
                      class="mt5 cursor"
                      src="@/assets/img/detils/001.png"
                      alt
                      @click="websiteUrl(detai2)"
                    />
                  </div>
                  <div class="time sz16 mb20" v-if="detai2.registeTime">
                    注册时间:
                    <span>{{ detai2.registeTime }}</span>
                  </div>
                  <div class="mb10" v-if="detai2.title">简介</div>

                  <div class>
                    <div class="introduction">
                      <p class="sz12 lep" v-if="detai2">
                        <span @mouseenter="mouseover" @mouseleave="mouseout">{{
                          detai2.introduce
                        }}</span>
                      </p>
                    </div>
                    <!-- <div class="detailstop">
                      <div class="rectan" v-if="allstuts">
                        <div class="rectangle coff sz12" v-if="detai2">{{ detai2.introduce }}</div>
                      </div>
                    </div> -->
                  </div>
                  <div
                    class="tabs_b flex alcen"
                    v-if="typesName !== 'B端' && detai2.title"
                  >
                    <el-tooltip class="item" effect="dark" placement="bottom">
                      <div slot="content">
                        <p class="mb10">
                          *本平台将含有分销链接的内容，定义为“带货视频”/“带货内容”
                        </p>
                        <p class="mb10">
                          并基于过去一年内的活跃带货分销数据进行分析，计算出页面
                        </p>
                        <p class="mb10">呈现的相关数据指标。</p>
                      </div>
                      <i class="el-icon-question questionIcon"></i>
                    </el-tooltip>
                  </div>

                  <div class="num flex">
                    <div
                      class="num_list flex mb20"
                      v-for="(item, index) in detai2.formField"
                      :key="index"
                    >
                      <div>
                        <p class="sz12 co70">{{ item.labelName }}</p>
                        <p class="sz20 co00">{{ item.value }}</p>
                      </div>
                      <div
                        class="num_list_img ru50 flex jucen alcen"
                        :class="bgclass(item.labelName)"
                      >
                        <img :src="iconImg(item.labelName)" alt />
                      </div>
                    </div>
                  </div>
                  <div
                    class="blocktitle"
                    v-show="typesName == 'YouTube' && youtubeVideos.length > 0"
                  >
                    <span class="nodered"></span>近期带货视频
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="bottom"
                      content="Youtube 作者近期发布的详情含有带货链接的视频"
                    >
                      <i class="el-icon-question questionIcon"></i>
                    </el-tooltip>
                  </div>
                  <div
                    class="videobox flex"
                    v-show="typesName == 'YouTube' && youtubeVideos.length > 0"
                  >
                    <div
                      class="item"
                      v-for="(item, index) in youtubeVideos"
                      :key="index"
                    >
                      <!-- <div class="item_img"><img src="@/assets/img/test1.jpg" alt=""></div> -->
                      <div class="item_img">
                        <iframe
                          width="100%"
                          height="100%"
                          :src="'https://www.youtube.com/embed/' + item.videoId"
                          title="Target Circle Week is coming July 9-15!"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowfullscreen
                        ></iframe>
                      </div>
                      <div class="title" @click="openUrl(item.url)">
                        {{ item.title }}
                      </div>
                      <div class="num">
                        {{ item.viewingTimes }}次观看 ·
                        {{ formatDate(item.releaseTime) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- lwl开发测试结束 -->
      </div>
    </div>
    <div class="grouping" v-if="groupingstuts">
      <div class="top ru5">
        <div class="top_icon cursor" @click="gbtca">
          <i class="el-icon-close"></i>
        </div>
        <div class="top_top flex">
          <div
            class="top_p cursor"
            v-for="(ite, index) in follListTwo"
            :key="index"
            @click="addfools(ite, index)"
          >
            <div class="top_img flex" :class="ite.isname ? 'borre' : ''">
              <img src="@/assets/img/foll/wjj.png" alt />
            </div>
            <p class="sz14">{{ ite.groupName }}</p>
          </div>
        </div>
        <div class="butt">
          <div class="button_div cursor" @click="follsubmit">确定</div>
          <div class="text sz12" v-if="follListTwo.length < 3">
            进入我的关注页面可创建更多分组
          </div>
          <div class="text sz12" v-if="follListTwo.length > 2">可多选</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ALLIANCEDETAILPART1,
  ALLIANCEDETAILPART2,
  REMOVEGROUPONEDETAIL,
  JOINGROUP,
  QUERYUSERGROUP,
} from "../../api/foll";
import { QUERY, CHECKBATCHSENDEMAIL } from "../../api/emial";
import { formatTimes } from "../../utils/common";
import { RECORDS } from "../../api/personal";
import {
  QUERYHASGROUP,
  QUERYDETAILCHARTS,
  QUERYVIDEOLINKS,
  QUERYDETAILClOUDWORD,
} from "../../api/cutting";
import "echarts-wordcloud";
export default {
  data() {
    return {
      allianceCode: this.$route.query.code,
      detai: {},
      detai2: {},
      detai2List: [],
      follList: [], // 分组列表
      follListtwo: [], // 分组列表
      conlist: [], // 勾选列表
      detcont: [], //加入分组选中的数据
      googs: [], // 带货连接,
      typesName: "",
      allstuts: false,
      groupingstuts: false,
      follListTwo: [], // 分组列表
      detaillist: [], //选中的分株
      currentProgressId: "",
      scrollResultWidth: 0, //transform滚动的距离
      signleWidth: 100, //单个流程的宽度
      signleWidthtwo: 180, //单个流程的宽度
      activeName: 0,
      currentClickNumber: 0,
      progressList: [],
      progressListTwo: [],
      noScrollRight: true,
      borstuts: 0,
      tags: [],
      tagsList: [],

      brandtable: [{}, {}, {}, {}, {}],
      brandChart: [],
      countryChart: [{}, {}, {}, {}],
      industryChart: [{}, {}, {}, {}],
      dhhyXData: [],
      dhhyData: [],
      youtubeVideos: [],
      focusTopic: [],
      contentStyle: [],
      contentType: [],
      customColors: ["#f56c6c", "#e6a23c", "#5cb87a", "#1989fa", "#6f7ad3"],
      colorBox: [
        "#bd2760",
        "rgb(176, 70, 109)",
        "rgb(209, 132, 160)",
        "rgb(235, 181, 200)",
        "rgb(247, 215, 226)",
      ],
      focusTopicNum: 1,
      contentTypeNum: 1,
      contentStyleNum: 1,
      chartnum1: 0,
      chartnum2: 0,
      chartnum3: 0,
      chartnum4: 0,
    };
  },
  mounted() {
    this.allianceDetailPart1();
    this.queryUserGroup();
    this.queryDetailCharts();

    window.onresize = () => {
      if (this.typesName === "渠道详情") {
        this.$nextTick(() => {
          this.getWorld();
        });
      }
    };
  },
  methods: {
    iconImg(val) {
      const ba1 = ["订阅数", "粉丝数", "跳出率", "预估成交"];
      const ba2 = ["总观看数", "月访问量"];
      const ba3 = ["总视频数", "带货内容平均互动率"];
      const ba4 = ["近1年带货视频数"];
      const ba5 = ["带货视频平均观看次数", "带货内容平均互动率"];
      const ba6 = ["带货内容平均评论数", "带货视频平均评论数"];
      const ba7 = ["总帖子数", "平均访问页数"];
      const ba8 = ["近一年带货内容数", "近1年带货内容数"];
      const ba9 = ["总获赞数"];
      const ba10 = ["进驻渠道"];
      const ba11 = ["进驻商家"];
      const ba12 = ["Karma分"];

      if (ba1.includes(val)) {
        return require("@/assets/img/detils/002.png");
      } else if (ba2.includes(val)) {
        return require("@/assets/img/detils/003.png");
      } else if (ba3.includes(val)) {
        return require("@/assets/img/detils/004.png");
      } else if (ba4.includes(val)) {
        return require("@/assets/img/detils/005.png");
      } else if (ba5.includes(val)) {
        return require("@/assets/img/detils/006.png");
      } else if (ba6.includes(val)) {
        return require("@/assets/img/detils/007.png");
      } else if (ba7.includes(val)) {
        return require("@/assets/img/detils/009.png");
      } else if (ba8.includes(val)) {
        return require("@/assets/img/detils/010.png");
      } else if (ba9.includes(val)) {
        return require("@/assets/img/detils/011.png");
      } else if (ba10.includes(val)) {
        return require("@/assets/img/detils/012.png");
      } else if (ba11.includes(val)) {
        return require("@/assets/img/detils/013.png");
      } else if (ba12.includes(val)) {
        return require("@/assets/img/detils/014.png");
      }
    },
    bgclass(val) {
      const ba1 = ["订阅数", "粉丝数", "跳出率", "预估成交"];
      const ba2 = [
        "总观看数",
        "总帖子数",
        "平均访问页数",
        "总获赞数",
        "点赞数",
        "进驻商家",
        "月访问量",
        "Karma分",
      ];
      const ba3 = [
        "总视频数",
        "带货内容平均互动率",
        "总视频数",
        "带货内容平均互动率",
      ];
      const ba4 = [
        "近1年带货视频数",
        "近1年带货内容数",
        "近一年带货内容数",
        "总视频数",
      ];
      const ba5 = [
        "带货视频平均观看次数",
        "带货内容平均互动率",
        "进驻渠道",
        "月访问量",
      ];
      const ba6 = ["带货内容平均评论数", "带货视频平均评论数"];
      if (ba1.includes(val)) {
        return "ba1";
      } else if (ba2.includes(val)) {
        return "ba2";
      } else if (ba3.includes(val)) {
        return "ba3";
      } else if (ba4.includes(val)) {
        return "ba4";
      } else if (ba5.includes(val)) {
        return "ba5";
      } else if (ba6.includes(val)) {
        return "ba6";
      } else {
        return "ba2";
      }
    },
    formatDate(times) {
      return formatTimes(times);
    },
    customColorMethod(percentage) {
      if (percentage < 30) {
        return "#909399";
      } else if (percentage < 70) {
        return "#e6a23c";
      } else {
        return "#67c23a";
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    queryDetailCharts() {
      QUERYDETAILCHARTS({ allianceCode: this.allianceCode }).then((res) => {
        this.brandChart = res.data.body.brand;
        let tempValue = res.data.body.brand.value;
        let temp = [];
        res.data.body.brand.name.forEach((item, index) => {
          temp.push({
            name: item,
            value: tempValue[index],
          });
        });
        let dhhyXDataTemp = [];
        let dhhyDataTemp = [];
        this.brandtable = temp;
        this.countryChart = res.data.body.country;
        this.industryChart = res.data.body.industry;
        this.countryChart.forEach((item, index) => {
          item.itemStyle = {
            color: this.colorBox[index]
              ? this.colorBox[index]
              : "rgb(209, 132, 160)",
          };
        });
        this.industryChart.forEach((item, index) => {
          dhhyXDataTemp.push(item.name);
          dhhyDataTemp.push(item.value);
          item.itemStyle = {
            color: this.colorBox[index]
              ? this.colorBox[index]
              : "rgb(209, 132, 160)",
          };
        });

        this.dhhyXData = res.data.body.affilate.name;
        this.dhhyData = res.data.body.affilate.value;
        if (this.countryChart) {
          this.chartnum1 = this.countryChart.length;
        } else {
          this.chartnum1 = 0;
        }
        if (this.dhhyData) {
          this.chartnum2 = this.dhhyData.length;
        } else {
          this.chartnum2 = 0;
        }
        if (this.brandChart.value) {
          this.chartnum3 = this.brandChart.value.length;
        } else {
          this.chartnum3 = 0;
        }
        if (this.industryChart) {
          this.chartnum4 = this.industryChart.length;
        } else {
          this.chartnum4 = 0;
        }
        if (this.typesName === "渠道详情") {
          this.$nextTick(() => {
            this.getWorld();
          });
        }
      });
    },
    mouseover() {
      if (this.detai2.introduce) {
        this.allstuts = true;
      }
    },
    mouseout() {
      this.allstuts = false;
    },
    sendOut(e) {
      if (e.hasEmail == 1) {
        CHECKBATCHSENDEMAIL({ allianceCodes: [e.allianceCode] }).then((res) => {
          if (res.data.code === "success") {
            if (res.data.body.sendEmailCount > 0) {
              // let routeUrl = this.$router.resolve({
              //   path: "emailConnection",
              //   query: { allianceCode: e.allianceCode, name: e.name },
              // });
              // window.open(routeUrl.href);
              this.$router.push({
                path: "emailConnection",
                query: { allianceCode: e.allianceCode, name: e.name },
              });
              localStorage.setItem("isSelect", 3);
            } else {
              this.$message.warning(
                "为了避免打扰，且营造一个友好合作环境，系统将限制发送给同一联盟客的邮件数量为每7天1封。您已经在过去的7天内向此合作伙伴发送过电子邮件。请稍后再试。"
              );
            }
          }
        });
      }
    },
    checkImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });
    },
    allianceDetailPart1() {
      ALLIANCEDETAILPART1({
        allianceCode: this.allianceCode,
      }).then((res) => {
        this.detai = res.data.body;
        if (res.data.body.goods) {
          this.goods = [];
          let googsALL = res.data.body.goods.split("#nbsp;");
          googsALL.forEach((item) => {
            this.checkImage(item).then((img) => {
              if (img.width > 10 && img.height > 10) {
                this.googs.push(img.src);
              }
            });
          });
        }
        if (this.detai.brands) {
          this.detai.brands = this.detai.brands.split(",");
        }
        if (this.detai.myGroupNames) {
          this.detai.myGroupNames = this.detai.myGroupNames.split(",");
        }
        if (this.detai.types) {
          this.detai.types = this.detai.types.split(",");
        }
        if (this.detai.affiliateNetworkLogos) {
          this.detai.affiliateNetworkLogos =
            this.detai.affiliateNetworkLogos.split(",");
        }
        if (this.detai.affiliateNetworks) {
          this.detai.affiliateNetworks =
            this.detai.affiliateNetworks.split(",");
        }
        if (this.detai.promoType) {
          this.detai.promoType = this.detai.promoType.split(",");
        }
        ALLIANCEDETAILPART2({
          allianceCode: this.allianceCode,
        }).then((res) => {
          if (res.data.body) {
            this.detai2List = res.data.body;
            if (res.data.body && res.data.body.length < 1) {
              this.detailclick();
            } else {
              this.detai2 = res.data.body[0].data;
              this.typesName = res.data.body[0].prompType;
              if (res.data.body[0].prompType == "YouTube") {
                QUERYVIDEOLINKS({ allianceCode: this.allianceCode }).then(
                  (res) => {
                    this.youtubeVideos = res.data.body;
                  }
                );
              }
              if (this.detai2.tags) {
                this.tags = this.detai2.tags.split(",");
              }
              var arr = [];
              if (this.detai2.communityModerators) {
                arr = this.detai2.communityModerators.split(";");
                if (res.data.body[0].prompType == "Reddit") {
                  this.$nextTick(() => {
                    setTimeout(() => {
                      this.initgoRightArrow();
                    });
                  });
                }
              }
              arr.map((item) => {
                let obj = {
                  value: item.split("::")[0],
                  cont: item.split("::")[1],
                };
                this.progressListTwo.push(obj);
              });
            }
          }
        });
      });
    },
    // 分组-查询用户下全部分组
    queryUserGroup() {
      QUERYUSERGROUP().then((res) => {
        this.titname = res.data.body[0].groupName;
        if (!this.groupCode) {
          this.groupCode = res.data.body[0].groupCode;
        }
        this.follList = [];
        this.follListtwo = [];
        let arr = res.data.body;
        arr.map((item) => {
          this.follList.push(Object.assign({}, item, { isname: true }));
          this.follListtwo.push(Object.assign({}, item, { isname: true }));
        });
        this.conlist = [];
        let arr1 = res.data.body;
        arr1.map((item) => {
          this.conlist.push(Object.assign({}, item, { isconts: false }));
        });
        this.follList.map((item, index) => {
          if (item.headSrcs) {
            item.headSrcs = item.headSrcs.split(",");
          }
        });
        this.follListtwo.map((item, index) => {
          if (item.headSrcs) {
            item.headSrcs = item.headSrcs.split(",");
          }
        });
      });
    },
    //初始化判断是否可以向右滚动
    initgoRightArrow() {
      const currentScrollWidth = this.$refs[`fixedBoxTwo`].clientWidth;
      const canNumber = Math.floor(currentScrollWidth / this.signleWidthtwo); //可以放下的个数
      //如果最后一个流程图标已经展示出来，则停止滚动
      if (this.currentClickNumber + canNumber >= this.progressListTwo.length) {
        this.noScrollRight = false;
        return;
      }
    },
    initgoRightArrow1() {
      const currentScrollWidth1 = this.$refs[`fixedBox`].clientWidth;
      const canNumber1 = Math.floor(currentScrollWidth1 / this.signleWidth); //可以放下的个数
      //如果最后一个流程图标已经展示出来，则停止滚动
      if (this.currentClickNumber + canNumber1 >= this.progressList.length) {
        this.noScrollRight = false;
        return;
      }
    },
    //点击上一个
    fnPrev() {
      //如果右点击的次数大于0，才可以左滚
      if (this.currentClickNumber > 0) {
        this.currentClickNumber -= 1;
        this.noScrollRight = true;
        this.fnScrollWidth("reduce");
      } else {
        return false;
      }
    },
    fnPrevtwo() {
      if (this.currentClickNumber > 0) {
        this.currentClickNumber -= 1;
        this.noScrollRight = true;
        this.fnScrollWidth("reduce");
      } else {
        return false;
      }
    },
    //点击下一个
    fnNext() {
      const currentScrollWidth1 = this.$refs[`fixedBox`].clientWidth;
      const canNumber1 = Math.floor(currentScrollWidth1 / this.signleWidth); //可以放下的个数
      //如果最后一个流程图标已经展示出来，则停止滚动
      if (this.currentClickNumber + canNumber1 >= this.progressList.length) {
        return;
      }
      //说明放不下有滚动条
      if (this.progressList.length > canNumber1) {
        this.currentClickNumber += 1;
        if (this.currentClickNumber + canNumber1 >= this.progressList.length) {
          this.noScrollRight = false;
        }
        this.fnScrollWidth("add");
      }
    },
    //translate的宽度
    fnScrollWidth(type) {
      let result = 0;
      if (type === "reduce") {
        result = 100;
      } else if (type === "add") {
        result = -100;
      } else {
        result = 0;
      }
      this.scrollResultWidth += result;
    },
    fnNextTwo() {
      const currentScrollWidth = this.$refs[`fixedBoxTwo`].clientWidth;
      const canNumber = Math.floor(currentScrollWidth / this.signleWidthtwo); //可以放下的个数
      //如果最后一个流程图标已经展示出来，则停止滚动
      if (this.currentClickNumber + canNumber >= this.progressListTwo.length) {
        return;
      }
      //说明放不下有滚动条
      if (this.progressListTwo.length > canNumber) {
        this.currentClickNumber += 1;
        if (
          this.currentClickNumber + canNumber >=
          this.progressListTwo.length
        ) {
          this.noScrollRight = false;
        }
        this.fnScrollWidth("add");
      }
    },
    // 移除关注分组
    delConcern(e) {
      REMOVEGROUPONEDETAIL({
        groupCode: "concern001",
        allianceCode: e.allianceCode,
      }).then((res) => {
        if (res.data.code == "success") {
          this.allianceDetailPart1();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 加入到关注分组
    addConcern(e) {
      let userGroups = [
        {
          groupCode: "concern001",
          allianceCode: e.allianceCode,
        },
      ];
      JOINGROUP({ userGroups }).then((res) => {
        if (res.data.code == "success") {
          this.allianceDetailPart1();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 移除合作分组
    delCooperate(e) {
      REMOVEGROUPONEDETAIL({
        groupCode: "cooperate001",
        allianceCode: e.allianceCode,
      }).then((res) => {
        if (res.data.code == "success") {
          this.allianceDetailPart1();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 加入合作分组
    addCooperate(e) {
      let userGroups = [
        {
          groupCode: "cooperate001",
          allianceCode: e.allianceCode,
        },
      ];
      JOINGROUP({ userGroups }).then((res) => {
        if (res.data.code == "success") {
          this.allianceDetailPart1();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 加入分组多选按钮
    chiscont(index, e, v) {
      this.conlist[index].isconts = !this.conlist[index].isconts;
      if (e.isconts == true) {
        this.detcont.push({
          groupCode: e.groupCode,
          allianceCode: v.allianceCode,
        });
      } else {
        this.detcont.splice(i, 1);
      }
    },
    // 加入分组保存
    preservation() {
      if (!this.detcont.length) {
        this.$message.warning("请先选择");
        return;
      }
      JOINGROUP({
        userGroups: this.detcont,
      }).then((res) => {
        if (res.data.code == "success") {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.queryUserGroup();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    cancelfol() {},

    // 确认添加
    follsubmit() {
      if (!this.detaillist.length) {
        this.$message.warning("请选择分组");
        return;
      }
      JOINGROUP({
        userGroups: this.detaillist,
      }).then((res) => {
        if (res.data.code == "success") {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.groupingstuts = false;
          this.detaillist = [];
          this.follListTwo = [];
          for (var i = 0; i < this.follListTwo.length; i++) {
            this.follListTwo[i].isname = false;
          }
          this.allianceDetailPart1();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 选择分组
    addfools(e, index, v) {
      this.follListTwo[index].isname = !this.follListTwo[index].isname;
      for (var i = 0; i < this.follListTwo.length; i++) {
        if (this.follListTwo[i].isname == false) {
          // this.chooseAll = false;
          break;
        }
      }
      if (i == this.follListTwo.length) {
      }
      if (e.isname == true) {
        this.detaillist.push({
          groupCode: e.groupCode,
          allianceCode: this.allianceCode,
        });
      } else {
        this.detaillist.splice(i, 1);
      }
    },
    // 加入到分组
    addgrouping(e) {
      this.allianceCode = e.allianceCode;
      this.follListTwo = [];
      QUERY().then((res) => {
        if (res.data.code == "success") {
          QUERYHASGROUP({ allianceCode: e.allianceCode }).then((res) => {
            if (res.data.body.length === this.follList.length) {
              this.$message.warning(
                "暂无可添加的分组,您可以到我的关注页面添加新的分组"
              );
            } else {
              this.groupingstuts = true;
              let ary02 = res.data.body;
              for (var i = 0; i < this.follList.length; i++) {
                for (var j = 0; j < ary02.length; j++) {
                  if (this.follList[i].groupCode == ary02[j]) {
                    this.follList[i] = "";
                    break;
                  }
                }
              }
              for (var i = 0; i < this.follList.length; i++) {
                if (this.follList[i] != "") {
                  this.follListTwo.push(this.follList[i]);
                }
              }
              for (var i = 0; i < this.follListTwo.length; i++) {
                var item = this.follListTwo[i];
                if (item.isname) {
                  item.isname = false;
                }
              }
            }
          });
        } else {
          this.$router.push("./");
        }
      });
    },
    // 关闭分组
    gbtca() {
      this.groupingstuts = false;
      this.detaillist = [];
      this.follListTwo = [];
      for (var i = 0; i < this.follListTwo.length; i++) {
        var item = this.follListTwo[i];
        if (item.isname) {
          item.isname = false;
        }
      }
    },
    detailclick() {
      this.borstuts = "default";
      this.typesName = "渠道详情";
      this.$nextTick(() => {
        this.getWorld();
      });
    },
    borscick(e, index) {
      this.borstuts = index;
      this.typesName = e.prompType;
      this.detai2 = e.data;
      var arr = [];
      if (e.data.communityModerators) {
        arr = e.data.communityModerators.split(";");
        if (e.prompType == "Reddit") {
          this.$nextTick(() => {
            setTimeout(() => {
              this.initgoRightArrow();
            });
          });
        }
      }
      if (e.data.gameName) {
        this.progressList = e.data.gameName.split(",");
        if (e.promoType == "Twitch") {
          this.$nextTick(() => {
            setTimeout(() => {
              this.initgoRightArrow1();
            });
          });
        }
      }
      arr.map((item) => {
        let obj = { value: item.split("::")[0], cont: item.split("::")[1] };
        this.progressListTwo.push(obj);
      });
      if (e.prompType == "YouTube") {
        QUERYVIDEOLINKS({ allianceCode: this.allianceCode }).then((res) => {
          this.youtubeVideos = res.data.body;
        });
      }
      if (e.prompType == "Twitch") {
        this.tagsList = e.data.tags.split(",");
      }
    },
    websiteUrl(e) {
      window.open(e.websiteUrl);
    },
    openUrl(url) {
      window.open(url);
    },

    getWorld() {
      if (this.chartnum1 > 0) {
        this.drawChart1();
      }
      if (this.chartnum2 > 0) {
        this.drawChartdhhyZ();
      }
      if (this.chartnum3 > 0) {
        this.drawCharthzpp();
      }
      if (this.chartnum4 > 0) {
        this.drawChart2();
      }

      QUERYDETAILClOUDWORD({ allianceCode: this.allianceCode }).then((res) => {
        let focusTopic = res.data.body.focusTopic
          ? res.data.body.focusTopic
          : [];
        let contentStyle = res.data.body.contentStyle
          ? res.data.body.contentStyle
          : [];
        this.contentType = res.data.body.contentType;
        this.focusTopic = [];
        this.contentStyle = [];
        if (focusTopic) {
          focusTopic.forEach((item, index) => {
            this.focusTopic.push({
              name: item[0],
              value: item[1],
            });
          });
        }
        if (contentStyle) {
          contentStyle.forEach((item, index) => {
            this.contentStyle.push({
              name: item[0],
              value: item[1],
            });
          });
        }
        if (this.contentType) {
          this.contentType.forEach((item, index) => {
            if (index < 5) {
              item.itemStyle = {
                color: this.colorBox[index] ? this.colorBox[index] : "",
              };
            }
          });
        }
        if (this.contentType) {
          this.contentTypeNum = this.contentType.length;
        } else {
          this.contentTypeNum = 0;
        }
        if (this.contentStyle) {
          this.contentStyleNum = this.contentStyle.length;
        } else {
          this.contentStyleNum = 0;
        }
        if (this.focusTopic) {
          this.focusTopicNum = this.focusTopic.length;
        } else {
          this.focusTopicNum = 0;
        }
        if (this.contentTypeNum > 0) {
          this.drawChart6();
        }
        if (this.focusTopicNum > 0) {
          this.drawWordCloud1();
        }
        if (this.contentStyleNum > 0) {
          this.drawWordCloud2();
        }
      });
    },
    drawChart1() {
      // 基于准备好的dom，初始化echarts实例
      let chart = this.$echarts.init(document.getElementById("chart1"));
      // 监听屏幕变化自动缩放图表
      window.addEventListener("resize", function () {
        chart.resize();
      });
      // 绘制图表
      chart.setOption({
        tooltip: {
          trigger: "item",
        },
        label: {
          formatter: "{b|{b}：{c}}{abg|}\n{hr|}\n   {a|{d}%}   ",
          backgroundColor: "#F6F8FC",
          borderColor: "#8C8D8E",
          borderWidth: 1,
          borderRadius: 4,
          rich: {
            a: {
              color: "#6E7079",
              lineHeight: 22,
              align: "center",
              padding: 10,
            },
            hr: {
              borderColor: "#8C8D8E",
              width: "100%",
              borderWidth: 1,
              height: 0,
            },
            b: {
              color: "#4C5058",
              fontSize: 12,
              align: "center",
              fontWeight: "bold",
              lineHeight: 25,
              padding: [5, 5, 5, 5],
            },
            per: {
              color: "#fff",
              backgroundColor: "#4C5058",
              padding: [3, 4],
              borderRadius: 4,
            },
          },
        },
        series: [
          {
            name: "区域影响力",
            type: "pie",
            radius: ["40%", "55%"],
            data: this.countryChart,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    drawChart2() {
      // 基于准备好的dom，初始化echarts实例
      let chart = this.$echarts.init(document.getElementById("chart2"));
      // 监听屏幕变化自动缩放图表
      window.addEventListener("resize", function () {
        chart.resize();
      });
      // 绘制图表
      chart.setOption({
        tooltip: {
          trigger: "item",
        },
        label: {
          formatter: "{b|{b}：{c}}{abg|}\n{hr|}\n   {a|{d}%}   ",
          backgroundColor: "#F6F8FC",
          borderColor: "#8C8D8E",
          borderWidth: 1,
          borderRadius: 4,
          rich: {
            a: {
              color: "#6E7079",
              lineHeight: 22,
              align: "center",
              padding: 10,
            },
            hr: {
              borderColor: "#8C8D8E",
              width: "100%",
              borderWidth: 1,
              height: 0,
            },
            b: {
              color: "#4C5058",
              fontSize: 12,
              align: "center",
              fontWeight: "bold",
              lineHeight: 25,
              padding: [5, 5, 5, 5],
            },
            per: {
              color: "#fff",
              backgroundColor: "#4C5058",
              padding: [3, 4],
              borderRadius: 4,
            },
          },
        },
        series: [
          {
            name: "带货行业",
            type: "pie",
            radius: ["40%", "55%"],
            data: this.industryChart,

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    drawChartdhhyZ() {
      // 基于准备好的dom，初始化echarts实例
      let chart = this.$echarts.init(document.getElementById("chartdhhyZ"));
      // 监听屏幕变化自动缩放图表
      window.addEventListener("resize", function () {
        chart.resize();
      });
      // 绘制图表
      chart.setOption({
        grid: {
          x: 90,
          y2: 60,
        },
        xAxis: {
          type: "category",
          data: this.dhhyXData,
          axisLabel: {
            // 旋转角度
            rotate: 15,
          },
        },
        yAxis: {
          type: "value",
          minInterval: 1,
          axisLabel: {
            // 旋转角度
            rotate: 15,
          },
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            data: this.dhhyData,
            type: "bar",
            barWidth: 15,
            showBackground: true,
            color: "rgba(190, 60, 110, 1)",
            backgroundStyle: {
              color: "rgba(252, 240, 244, 1)",
            },
          },
        ],
      });
    },
    drawCharthzpp() {
      // 基于准备好的dom，初始化echarts实例
      let chart = this.$echarts.init(document.getElementById("charthzpp"));
      // 监听屏幕变化自动缩放图表
      window.addEventListener("resize", function () {
        chart.resize();
      });
      // 绘制图表
      chart.setOption({
        grid: {
          x: 50,
          y2: 60,
        },
        xAxis: {
          type: "category",
          data: this.brandChart.name,
          axisLabel: {
            // 旋转角度
            rotate: 15,
          },
        },

        yAxis: {
          type: "value",
          minInterval: 1,
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            data: this.brandChart.value,
            type: "bar",
            barWidth: 15,
            showBackground: true,
            color: "rgba(190, 60, 110, 1)",
            backgroundStyle: {
              color: "rgba(252, 240, 244, 1)",
            },
          },
        ],
      });
    },
    drawChart6() {
      // 基于准备好的dom，初始化echarts实例
      let chart = this.$echarts.init(document.getElementById("chart6"));
      // 监听屏幕变化自动缩放图表
      window.addEventListener("resize", function () {
        chart.resize();
      });
      // 绘制图表
      chart.setOption({
        // tooltip: {
        //   trigger: "item"
        // },
        label: {
          formatter: "{b|{b}}{abg|}\n{hr|}\n   {a|{d}%}   ",
          backgroundColor: "#F6F8FC",
          borderColor: "#8C8D8E",
          borderWidth: 1,
          borderRadius: 4,
          rich: {
            a: {
              color: "#6E7079",
              lineHeight: 22,
              align: "center",
              padding: 10,
            },
            hr: {
              borderColor: "#8C8D8E",
              width: "100%",
              borderWidth: 1,
              height: 0,
            },
            b: {
              color: "#4C5058",
              fontSize: 12,
              align: "center",
              fontWeight: "bold",
              lineHeight: 25,
              padding: [5, 5, 5, 5],
            },
            per: {
              color: "#fff",
              backgroundColor: "#4C5058",
              padding: [3, 4],
              borderRadius: 4,
            },
          },
        },
        series: [
          {
            name: "内容类型",
            type: "pie",
            radius: ["40%", "55%"],
            data: this.contentType,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    drawWordCloud1() {
      const dom = document.getElementById("jdht");
      let myChart = this.$echarts.init(dom);
      // 监听屏幕变化自动缩放图表
      window.addEventListener("resize", function () {
        myChart.resize();
      });
      myChart.setOption({
        series: [
          {
            type: "wordCloud",
            data: this.focusTopic,
            // shape这个属性虽然可配置，但是在词的数量不太多的时候，效果不明显，它会趋向于画一个椭圆
            // shape: 'circle',
            // 词的大小，最小12px，最大60px，可以在这个范围调整词的大小
            sizeRange: [12, 60],
            // 每个词旋转的角度范围和旋转的步进
            rotationRange: [0, 0],
            // 词间距，数值越小，间距越小，这里间距太小的话，会出现大词把小词套住的情况，比如一个大的口字，中间会有比较大的空隙，这时候他会把一些很小的字放在口字里面，这样的话，鼠标就无法选中里面的那个小字，这里可以用函数根据词云的数量动态返回间距
            gridSize: 8,
            // 允许词太大的时候，超出画布的范围
            drawOutOfBound: true,
            // 布局的时候是否有动画
            layoutAnimation: true,
            // 这是全局的文字样式，相对应的还可以对每个词设置字体样式
            textStyle: {
              fontFamily: "Verdana, Arial, Helvetica, sans-serif",
              fontWeight: "bold",
              // 颜色可以用一个函数来返回字符串，这里是随机色
              color: function (e) {
                let wordcloudColor = [
                  "#86D4FF",
                  "#FF8F6C",
                  "#2CF263",
                  "#9FA8F7",
                  "#1274FF",
                  "#E6613D",
                  "#FFC629",
                  "#FFAB2E",
                  "#F78289",
                  "#FF6C96",
                  "#45BFD4",
                  "#4E31FF",
                  "#31FBFB",
                  "#86D4FF",
                  "#BF8AFD",
                  "#FFF500",
                  "#DE58FF",
                  "#72ED7C",
                  "#0BEEB8",
                  "#931CFF",
                  "#3D25F2",
                  "#F995C8",
                  "#FBE9B4",
                  "#FF4AB6",
                ];
                return wordcloudColor[Math.round(Math.random() * 24)];
                // Random color
                // return 'rgb(' + [
                //   Math.round(Math.random() * 160),
                //   Math.round(Math.random() * 160),
                //   Math.round(Math.random() * 160)
                // ].join(',') + ')';
              },
            },
            emphasis: {
              focus: "self",
              textStyle: {
                textShadowBlur: 10,
                textShadowColor: "#ccc",
              },
            },
          },
        ],
      });
    },
    drawWordCloud2() {
      const dom = document.getElementById("chart7");
      let myChart = this.$echarts.init(dom);
      // 监听屏幕变化自动缩放图表
      window.addEventListener("resize", function () {
        myChart.resize();
      });
      myChart.setOption({
        series: [
          {
            type: "wordCloud",
            data: this.contentStyle,
            // shape这个属性虽然可配置，但是在词的数量不太多的时候，效果不明显，它会趋向于画一个椭圆
            shape: "circle",
            // 词的大小，最小12px，最大60px，可以在这个范围调整词的大小
            sizeRange: [20, 50],
            // 每个词旋转的角度范围和旋转的步进
            rotationRange: [0, 0],
            // 词间距，数值越小，间距越小，这里间距太小的话，会出现大词把小词套住的情况，比如一个大的口字，中间会有比较大的空隙，这时候他会把一些很小的字放在口字里面，这样的话，鼠标就无法选中里面的那个小字，这里可以用函数根据词云的数量动态返回间距
            gridSize: 8,
            // 允许词太大的时候，超出画布的范围
            drawOutOfBound: true,
            // 布局的时候是否有动画
            layoutAnimation: true,
            // 这是全局的文字样式，相对应的还可以对每个词设置字体样式
            textStyle: {
              fontFamily: "sans-serif",
              fontWeight: "bold",
              // 颜色可以用一个函数来返回字符串，这里是随机色
              color: function () {
                let wordcloudColor = [
                  "#86D4FF",
                  "#FF8F6C",
                  "#2CF263",
                  "#9FA8F7",
                  "#1274FF",
                  "#E6613D",
                  "#FFC629",
                  "#FFAB2E",
                  "#F78289",
                  "#FF6C96",
                  "#45BFD4",
                  "#4E31FF",
                  "#31FBFB",
                  "#86D4FF",
                  "#BF8AFD",
                  "#FFF500",
                  "#DE58FF",
                  "#72ED7C",
                  "#0BEEB8",
                  "#931CFF",
                  "#3D25F2",
                  "#F995C8",
                  "#FBE9B4",
                  "#FF4AB6",
                ];
                return wordcloudColor[Math.round(Math.random() * 24)];
              },
            },
            emphasis: {
              focus: "self",
              textStyle: {
                textShadowBlur: 10,
                textShadowColor: "rgba(190, 60, 110, 1)",
              },
            },
          },
        ],
      });
    },
  },
};
</script>
<style lang="less" scoped>
.questionIcon {
  font-size: 18px;
  cursor: pointer;
  margin-left: 5px;
  color: rgba(209, 132, 160, 1);
}

.h27 {
  height: 27px;
}

.mg {
  margin-right: 20px;
}

.mr30 {
  margin-right: 30px !important;
}

.borre {
  border: 2px solid #be3c6e;
}

.Bd {
  img {
    width: 13px;
    height: 13px;
    margin-bottom: -4px;
    margin-left: 5px;
  }
}

.bqlist_map {
  width: 100%;
  flex-wrap: wrap;

  .bqlist {
    height: 21px;
    background: rgba(166, 168, 191, 0.25);
    margin-right: 10px;
    padding: 0 10px;
  }
}

.processBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;

  .processBox_icon {
    width: 20px;
    height: 20px;
    background: rgba(166, 168, 191, 0.25);
  }

  img {
    width: 50px;
  }
}

.name_list {
  margin-left: 5px;
  width: 82%;

  .gemes {
    width: 100%;
  }

  .arrow {
    margin-bottom: -2px;
    cursor: pointer;
  }

  .arrowOpacity {
    cursor: default;
    opacity: 0.4;
  }

  .fixedBox {
    flex: 1;
    overflow: hidden;
    padding-left: 10px;
  }

  .centerScroll {
    // flex: 1;
    box-sizing: border-box;
    padding: 20px 0;
    white-space: nowrap;

    // width: calc(100% - 120px);
    // overflow-x: auto;
    .signleTabTwo {
      width: 180px;
      position: relative;
      display: inline-block;
    }

    .signleTab {
      width: 100px;
      position: relative;
      display: inline-block;

      .leftIcon {
        width: 100px;
        text-align: center;
        cursor: pointer;

        & > .pregressIcon {
          width: 60px;
          height: 60px;
        }

        .leftIcon_img {
          width: 36px;
          height: 36px;

          img {
            width: 36px;
          }
        }
      }

      .leftIcontwo {
        width: 180px;
        text-align: center;
        cursor: pointer;

        & > .pregressIcon {
          width: 60px;
          height: 60px;
        }

        .leftIcon_img {
          width: 36px;
          height: 36px;

          img {
            width: 36px;
          }
        }
      }

      & > .arrowSquare {
        position: absolute;
        top: 25px;
        right: 0;
      }
    }
  }

  .name_icon {
    width: 15px;
    height: 15px;
    background: rgba(166, 168, 191, 0.25);

    i {
      font-size: 12px;
    }
  }
}

.w80 {
  width: 80px;
}

.grouping {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 9999;

  .top {
    max-width: 615px;
    min-width: 300px;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -240px;
    margin-left: -340px;

    .top_icon {
      width: 100%;
      text-align: right;
      font-size: 28px;
      padding: 15px 15px 0 0;
    }

    .top_top {
      width: 100%;
      max-height: 320px;
      flex-wrap: wrap;
      overflow: auto;
      padding: 0 43px;

      .top_p {
        width: 140px;
        margin: 0 15px;
        margin-bottom: 8px;

        p {
          width: 100%;
          text-align: center;
          margin-top: 8px;
        }

        .top_img {
          width: 140px;
          height: 124px;
          box-shadow: 0px 5px 6px 1px rgba(0, 0, 0, 0.16);
          border-radius: 20px 20px 20px 20px;
          justify-content: center;
          align-items: center;

          img {
            width: 100px;
            height: 80px;
          }
        }
      }
    }

    .top_top::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      background: #be3c6e;
    }

    .top_top::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      border-radius: 10px;
      background: #ededed;
    }

    .top_top::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 4px;
      /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }

    .butt {
      width: 100%;
      margin-top: 30px;

      .button_div {
        width: 96px;
        height: 40px;
        background: #be3c6e;
        border-radius: 5px 5px 5px 5px;
        margin: 0 auto;
        line-height: 40px;
        text-align: center;
        color: #fff;
      }

      .text {
        width: 100%;
        text-align: center;
        color: #707070;
        font-size: 12px;
      }
    }
  }
}

.emalis {
  height: 100%;
  position: absolute;
  right: 26px;
  top: 0;

  .emalisimg {
    width: 29px;
    height: 29px;

    img {
      width: 100%;
    }
  }

  .emalimag {
    margin: 10px 0;

    .h22 {
      height: 22px;
    }

    .topsa {
      margin-top: 6px;
    }
  }
}

.detailstop {
  position: relative;
  height: 1px;
  z-index: 99999;
}

.w90 {
  max-width: 90px;
}

.rectan {
  width: 100%;
  padding-right: 100px;
  position: absolute;
  top: 10px;
  left: 0;

  .rectangle {
    width: 100%;
    border-radius: 15px;
    position: relative;
    background-color: #404040;
    padding: 12px;
    line-height: 20px;
  }

  /*小三角*/
  .rectangle::before {
    content: "";
    width: 0;
    height: 0;
    border: 15px solid;
    // border-color: #000 transparent transparent transparent;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #000;
    position: absolute;
    top: -25px;
    left: 50%;
  }
}

.yesemil {
  background: #be3c6e;
  color: #fff;
  cursor: pointer;
}

.noemail {
  color: #000;
  background: #404040;
  opacity: 0.5;
  cursor: not-allowed;
}

.mr {
  margin-right: 10px;
}

.h25 {
  height: 25px;
  line-height: 25px;
}

.titnames_1 {
  width: 50px;
}

.titnames_2 {
  min-width: 60px;
}

.pad10 {
  padding: 0 10px;
}

@keyframes move {
  from {
    transform: translate(0, 0);
  }

  to {
    transform: translate(-90%, 0);
  }
}

@keyframes moves {
  from {
    transform: translate(0, 0);
  }

  to {
    transform: translate(-50%, 0);
  }
}

.addfo {
  width: 520px;
  height: 360px;
  padding: 27px 0 0 36px;

  .nametit {
    width: 100%;
    margin-bottom: 28px;
  }

  .naelist_top {
    width: 100%;
    flex-wrap: wrap;

    .namelist {
      width: 100%;
      height: 19px;
      align-items: center;
      margin-bottom: 22px;
      width: 50%;

      input {
        width: 19px;
        height: 19px;
        margin-right: 16px;
      }
    }
  }
}

.name_butt {
  width: 100%;
  justify-content: center;
  margin-bottom: 12px;

  div {
    width: 110px;
    height: 40px;
    line-height: 40px;
  }

  .butt2 {
    border: 1px solid #be3c6e;
    margin-left: 60px;
  }
}

.mb8 {
  margin-bottom: 8px;
}

.mb30 {
  margin-bottom: 30px;
}

.mb23 {
  margin-bottom: 23px;
}

div {
  box-sizing: border-box;
}

@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .top_center {
    width: 1600px;
    margin: 0 auto;
  }
}

@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .top_center {
    width: 1920px;
    margin: 0 auto;
  }
}

.inbox {
  // padding-top: 112px;
  // margin-left: 276px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.inlbox {
  width: 98%;
  margin: 0 auto;
  margin-right: 28px;
}

.list {
  width: 100%;
  height: 150px;
  // border-bottom: 1px solid rgba(64, 64, 64, 0.24);
  padding-left: 15px;
  margin-bottom: 30px;
  margin-top: 30px;
  box-sizing: border-box;
  position: relative;

  .list_input {
    height: 100%;
    align-items: center;

    input {
      width: 28px;
      height: 28px;
    }
  }

  .name {
    padding: 15px;
    width: 150px;
    height: 100%;
    position: relative;

    .name_heder {
      width: 100%;
      height: 100%;
      position: relative;

      img {
        position: absolute;
        width: 100%;
        height: 100%;
        clip: rect(0px 180px 180px 1px);
      }

      .contacted {
        position: absolute;
        width: 150px;
        height: 75px;
        background: rgba(0, 0, 0, 0.3);
        bottom: 0;
        left: 0;
        line-height: 75px;
        border-radius: 0 0 75px 75px;
      }
    }

    p {
      width: 100%;
      margin-bottom: 9px;
      overflow: hidden;
      /*超出的部分隐藏起来。*/
      white-space: nowrap;
      /*不让文本换行,在一行显示*/
      text-overflow: ellipsis;
      /*超出显示...*/
    }

    .hotbq {
      position: absolute;
      top: -5px;
      left: -45px;
      transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      /* Internet Explorer */
      -moz-transform: rotate(-45deg);
      /* Firefox */
      -webkit-transform: rotate(-45deg);
      /* Safari 和 Chrome */
      -o-transform: rotate(-45deg);
      /* Opera */
    }

    .hotbq1 {
      position: absolute;
      top: -5px;
      left: -20px;
      transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      /* Internet Explorer */
      -moz-transform: rotate(-45deg);
      /* Firefox */
      -webkit-transform: rotate(-45deg);
      /* Safari 和 Chrome */
      -o-transform: rotate(-45deg);
      /* Opera */
    }
  }

  .category {
    margin: 0 15px 15px 10px;
    padding: 20px 0;
    width: 370px;
    border-right: 1px solid rgba(231, 232, 241, 1);

    .operateview {
      display: flex;

      .operateview_item {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        padding: 8px;
        background-color: rgba(233, 233, 238, 1);

        img {
          width: 100%;
          height: 100%;
        }
      }

      .operateview_item3 {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        padding: 8px;

        // padding: 12px 8px;
        background-color: rgba(233, 233, 238, 1);

        img {
          width: 100%;
          height: 100%;
        }
      }

      .operateview_item4 {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        padding: 7px;

        // padding: 12px 8px;
        background-color: rgba(233, 233, 238, 1);

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .scoreview {
    display: flex;
    width: 450px;
    border-right: 1px solid rgba(231, 232, 241, 1);
    padding: 20px 0;

    .scoreview_item {
      p {
        font-size: 20px;
        height: 40px;
        line-height: 40px;
        color: rgba(128, 128, 128, 1);
      }

      .score_val {
        height: 80px;
        font-size: 50px;
        font-weight: 700;
        line-height: 80px;
        color: rgba(190, 60, 110, 1);

        .dfont {
          font-size: 20px;
          font-weight: normal;
          color: rgba(166, 166, 166, 1);
        }
      }
    }
  }

  .affiliate {
    width: calc(100% - 920px);
    padding: 16px 20px;

    p {
      width: 100px;
      min-width: 75px;
      font-size: 20px;
      height: 40px;
      line-height: 40px;
      color: rgba(128, 128, 128, 1);
    }

    .foll_titless {
      width: calc(100% - 100px);
      display: flex;
      flex-wrap: wrap;
      /*超出的部分隐藏起来。*/
      white-space: nowrap;
      /*不让文本换行,在一行显示*/
      position: relative;
      box-sizing: border-box;
      overflow: hidden;

      padding-top: 5px;
      gap: 8px;
      p {
        width: 25%;
        height: 32px;
        line-height: 32px;
        text-align: left;
        margin-top: 4px;

        img {
          height: 100%;
        }
      }

      img {
        width: 32px;
        height: 32px;
        cursor: pointer;
      }
    }
  }

  ._top {
    margin-top: 3px;
  }

  .category_ttname {
    font-size: 23px;
    width: 250px;
    min-width: 80px;
    height: 40px;
    line-height: 40px;
    margin-right: 6px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.times {
  color: #a6a6a6;
  justify-content: flex-end;
}

.details {
  width: 100%;
  background-color: #fff;
  // box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);

  .detailbox {
    position: relative;

    .mohubox {
      position: absolute;
      width: 100%;
      height: calc(100% - 70px);
      top: 70px;
      background-color: #ffffff00;
      z-index: 999;
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
    }
  }

  .newtitle {
    color: #000;
    font-size: 14px;
    font-weight: 600;
    text-align: left;
    height: 30px;
    // padding-top: 15Px;
    // padding-left: 42px;

    i {
      cursor: pointer;
      margin-left: 5px;
      color: rgba(209, 132, 160, 1);
    }
  }

  .chart {
    padding: 20px 35px;
    position: relative;

    .otherbox {
      width: 100%;
      height: 100%;
      // box-shadow: 0px 0px 0px 2px rgba(231, 232, 241, 1);
      border-radius: 12px;
    }

    #chart1 {
      // box-shadow: 0px 0px 0px 2px rgba(231, 232, 241, 1);
      border-radius: 12px;
      height: 100%;

      .percentage {
        font-size: 16px;
        color: #606266;
        display: inline-block;
        vertical-align: middle;
        margin-left: 0.625rem;
        line-height: 1;
      }
    }

    #chart2 {
      // box-shadow: 0px 0px 0px 2px rgba(231, 232, 241, 1);
      border-radius: 12px;
      height: 100%;
    }

    #chartdhhyZ {
      border-radius: 12px;
      height: 100%;
    }

    #chart3 {
      // box-shadow: 0px 0px 0px 2px rgba(231, 232, 241, 1);
      border-radius: 12px;
      height: 100%;
    }

    #charthzpp {
      // box-shadow: 0px 0px 0px 2px rgba(231, 232, 241, 1);
      border-radius: 12px;
      height: 100%;
    }

    #chart5 {
      // padding: 15px;
      height: 95%;
      width: 95%;
      cursor: pointer;
      margin: 0 auto;

      #jdht {
        width: 100%;
        height: 100%;
      }
    }

    #chart6 {
      padding: 15px;
      height: calc(100% - 60px);
      width: 100%;
      margin: 0 auto;
    }

    #chart7 {
      // padding: 15px;
      height: calc(100% - 60px);
      width: 95%;
      cursor: pointer;
      margin: 0 auto;
    }

    .content {
      height: 400px;
      line-height: 400px;
      font-size: 38px;
      font-weight: 500;
      text-align: center;
    }

    .left_box {
      .top {
        height: 270px;
        display: flex;

        .top_l {
          display: flex;
          flex: 1;
          flex-direction: column;

          .item {
            width: 100%;
            text-align: center;
          }

          .item1 {
            margin-top: 100px;
            font-size: 21px;
            font-weight: 600;
            height: 50px;
            line-height: 50px;
          }

          .item2 {
            height: 50px;
            line-height: 50px;
            color: #ccc;
          }

          .item3 {
            height: 50px;
            line-height: 50px;
            font-size: 19px;
            font-weight: 500;
          }
        }

        #chart4 {
          flex: 1;
          height: 100%;
        }
      }

      .bottom {
        height: 180px;
      }
    }
  }

  .chartone {
    height: 320px !important;
  }

  .charttwo {
    padding-left: 0;
  }

  .chartthree {
    padding-right: 0;
  }

  .chartcontent {
    height: 500px !important;
  }

  .goodsnear {
    padding: 25px;

    .mohuboxgoods {
      position: absolute;
      width: 100%;
      height: calc(100% - 40px);
      top: 20px;
      background-color: #ffffff00;
      z-index: 999;
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
    }

    .content {
      height: 400px;
      line-height: 400px;
      font-size: 38px;
      font-weight: 500;
      text-align: center;
    }

    .newtitle {
      color: #000;
      font-size: 14px;
      height: 30px;
      font-weight: 600;
      text-align: left;
      // padding-left: 42px;
    }
  }

  .blocktitle {
    font-size: 20px;
    color: rgba(190, 60, 110, 1);
    font-weight: 600;
    height: 60px;
    line-height: 60px;
    border-bottom: 2px solid rgba(231, 232, 241, 1);
    margin-top: 20px;
    padding-left: 42px;
    position: relative;

    .nodered {
      position: absolute;
      display: inline-block;
      width: 8px;
      background-color: rgba(190, 60, 110, 1);
      height: 30px;
      left: 0;
      top: 15px;
    }
  }

  .blocktitleBord {
    font-size: 20px;
    color: rgba(190, 60, 110, 1);
    font-weight: 600;
    height: 80px;
    line-height: 60px;
    border-top: 20px solid #fafafd;
    border-bottom: 2px solid rgba(231, 232, 241, 1);
    padding-left: 42px;
    position: relative;

    .nodered {
      position: absolute;
      display: inline-block;
      width: 8px;
      background-color: rgba(190, 60, 110, 1);
      height: 30px;
      left: 0;
      top: 15px;
    }
  }

  .el-row {
    margin: 0;
  }

  .tabs {
    width: 97.5%;
    // height: 50px;
    padding-left: 42px;
    // padding-top: 10px;
    flex-wrap: wrap;

    div {
      font-size: 18px;
      height: 40px;
      line-height: 40px;
      margin-right: 20px;
      box-sizing: border-box;
    }
  }

  .tabs_b {
    // width: 6%;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    padding-top: 10px;

    p {
      width: 20px;
      height: 20px;
      border: 1px solid #be3c6e;
    }
  }

  .detils_li {
    padding: 20px 0 20px 40px;
  }

  .leftt {
    width: 100%;
    height: 100%;
    padding-left: 42px;
    padding-top: 20px;
    position: relative;

    // padding-left: 20px;
    .detai2bu {
      width: 100%;
      position: absolute;
      bottom: -5px;
    }

    .titlee {
      margin-bottom: 15px;
      height: 30px;

      img {
        width: 16px;
      }
    }

    .lep {
      margin-bottom: 10px;
      padding-right: 100px;
      line-height: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      // word-break: break-all;
    }

    .lep2 {
      margin-bottom: 10px;
      padding-right: 10px;
    }

    .time {
      margin-top: 10px;
    }

    .num {
      width: 100%;
      padding-right: 40px;
      margin-top: 10px;
      flex-wrap: wrap;
      justify-content: space-between;

      .num_list {
        width: 31%;
        height: 90px;
        box-shadow: 6px 6px 54px 1px rgba(0, 0, 0, 0.05);
        border-radius: 5px 5px 5px 5px;
        padding: 14px 14px;
        justify-content: space-between;

        .co70 {
          height: 31px;
          line-height: 31px;
        }

        .co00 {
          height: 31px;
          line-height: 31px;
        }

        .num_list_img {
          width: 66px;

          img {
            width: 23px;
          }
        }

        .ba1 {
          background: rgba(74, 217, 145, 0.21);
        }

        .ba2 {
          background: rgba(130, 128, 255, 0.21);
        }

        .ba3 {
          background: rgba(254, 197, 61, 0.21);
        }

        .ba4 {
          background: rgba(195, 173, 155, 0.21);
        }

        .ba5 {
          background: rgba(86, 153, 221, 0.21);
        }

        .ba6 {
          background: rgba(255, 144, 102, 0.21);
        }
      }

      .top {
        width: 100%;

        div {
          width: 50%;
          text-align: center;
        }

        .tooltips {
          .tooltips_d {
            width: 100%;

            p {
              position: relative;
              margin: 0 auto;
              width: 100px;
            }

            .tooltips_spanp {
              width: 155px;
            }

            .tooltips_span1 {
              border: 1px solid #707070;
              color: #707070;
              position: absolute;
              display: inline-block;
              width: 15px;
              height: 15px;
              border-radius: 50%;
              text-align: center;
              line-height: 15px;
              right: -10px;
              top: 13px;
              font-size: 12px;
            }

            .tooltips_span {
              border: 1px solid #707070;
              color: #707070;
              position: absolute;
              display: inline-block;
              width: 15px;
              height: 15px;
              border-radius: 50%;
              text-align: center;
              line-height: 15px;
              right: -15px;
              top: 13px;
              font-size: 12px;
            }
          }
        }
      }

      .butt {
        width: 100%;

        div {
          width: 50%;
          text-align: center;
        }
      }
    }

    .titclou {
      width: 160px;
    }

    .cloud {
      flex-wrap: wrap;
      width: 440px;
      justify-content: center;

      p {
        margin: 0 10px;
        color: #5a8cff;
      }
    }

    .num2 {
      width: 100%;
      padding-right: 40px;
      margin-top: 30px;

      .top {
        width: 100%;

        div {
          width: 100%;
          text-align: left;
        }
      }

      .butt {
        width: 100%;
        margin-top: 30px;

        div {
          width: 100%;
          text-align: center;
        }
      }
    }

    .introduction {
      // height: 130px;
      overflow: auto;
    }
  }

  .rightt {
    width: 100%;
    // box-shadow: 0px 0px 0px 2px rgba(231, 232, 241, 1);
    // box-shadow: 1px 1px 6px 2px rgba(235, 181, 200,1);
    border-radius: 12px;

    .rightt_center {
      width: 100%;

      .top {
        width: 100%;
        justify-content: space-between;
        padding-right: 23px;
        box-sizing: border-box;

        .top_img {
          width: 150px;
          height: 150px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            max-width: 99%;
            max-height: 99%;
          }
        }
      }
    }
  }
}

.videobox {
  margin-top: 15px;
  background-color: #fff;
  padding: 15px;
  flex-wrap: wrap;

  .item {
    border: 1px solid #ccc;
    cursor: pointer;
    border-radius: 10px;
    background-color: #fff;
    width: calc((100% - 45px) / 4);
    // flex: 1;
    color: #fff;
    border-radius: 10px;
    margin-right: 15px;
    margin-bottom: 15px;
    padding: 15px;
    color: #000;
    position: relative;

    .item_img {
      border-radius: 15px;

      img {
        border-radius: 15px;
      }
    }

    &:nth-child(4) {
      margin-right: 0px;
    }

    &:nth-child(8) {
      margin-right: 0px;
    }

    .title {
      line-height: 30px;
      padding: 0 20px;
      font-size: 19px;
      margin-top: 15px;
      margin-bottom: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .num {
      padding: 0 20px;
      color: #707070;
      position: absolute;
      bottom: 8px;
    }

    img {
      width: 100%;
    }
  }
}

.bor {
  color: #be3c6e;
  font-weight: 600;
  border-bottom: 4px solid #be3c6e;
}

.choosed {
  transform: scale(1.5);
}
</style>
<style lang="less">
.detailssdd {
  .el-input--suffix .el-input__inner {
    height: 100%;
    border: none;
  }

  .el-select {
    width: 100%;
  }

  .el-select > .el-input {
    width: 100%;
    height: 100%;
  }

  .el-pagination .el-select .el-input .el-input__inner {
    background: none;
  }

  .el-pager li {
    background: none;
  }

  .el-pagination button:disabled {
    background: none;
    // color: #be3c6e;
  }

  .el-pager li.active {
    color: #000;
    // color: #be3c6e;
    font-family: "OPPOSans-R";
    src: url("../../assets/ttf/OPPOSans-R.ttf");
  }

  /* .el-icon-arrow-up:before {
    color: #be3c6e;
  } */
  .el-range-editor.el-input__inner {
    width: 100%;
    border: none;
    padding-left: 50px;
  }

  .el-date-editor .el-range-separator {
    height: 100%;
    line-height: 56px;
  }

  .el-icon-date:before {
    color: #be3c6e;
    font-size: 28px;
  }

  .el-date-editor .el-range__icon {
    line-height: 56px;
    margin-right: 5px;
  }

  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    color: #fff;
    background: #be3c6e;
  }

  .el-drawer__wrapper {
    top: 70px;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    margin: 0;
  }

  .drawer_center {
    .el-icon-close:before {
      color: #232323;
    }
  }

  .templates_top {
    .el-popper[x-placement^="bottom"] {
      width: 206px !important;
    }
  }

  .send_img {
    .el-col-12 {
      width: 30px;
    }
  }
}

.top_imgreset {
  width: 150px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 10px auto;

  img {
    max-width: 99%;
    max-height: 99%;
  }
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.el-table .warning-row {
  background: rgba(252, 240, 244, 1);
}

.el-table .success-row {
  background: rgba(247, 215, 226, 1);
}

.el-progress-bar {
  width: calc(100% - 80px);
}

.el-table::before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}

.el-table__row {
  height: 45px;
}

.el-table__header-wrapper {
  .cell {
    color: #000 !important;
  }
}

.el-table__body-wrapper {
  background-color: #fcf0f4;
}

.goods_image {
  width: 200px !important;
  height: 200px !important;
  margin: 10px;
}
.goods_image img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
}
</style>
